import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocation } from 'react-router-dom';
import { faExclamationTriangle, faX, faUpload, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Spinner } from '../Loader/Loader';
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from '../Messages/Messages';
import { decryptData } from '../../utils/storageCrypto';
import { FiChevronDown, FiSearch } from "react-icons/fi";
import { MdAddLocationAlt } from 'react-icons/md';

function EditHub() {
  
  const [data, setData] = useState({
    hub_name: '',
    company_name: '',
    zoneId: '',
    email: '',
    mobile_number: '',
    gst: '',
    pan: '',
    address1: '',
    city: '',
    pincode: '',
    state: '',
    website_url: '',
    latitude: '',
    longitude: ''
  });
  const [errors, setErrors] = useState({});
  const [errorMessages, setErrorMessages] = useState([]);
  const location = useLocation();
  const { HubData: initialHubData } = location.state;
  const [HubData, setHubData] = useState({...initialHubData,
    latitude: initialHubData?.location?.lat || initialHubData?.latitude || '',
    longitude: initialHubData?.location?.lng || initialHubData?.longitude || ''});
  
  const [isSaving, setIsSaving] = useState(false);
  const [logo, setLogo] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const RETRY_LIMIT = 3;
  const [retryCount, setRetryCount] = useState(0);
  const [hubs, setHubs] = useState([]);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [retryFunction, setRetryFunction] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [image,setImage] = useState('');
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [closePopup, setClosePopup] = useState(false);
  const [BackToLoginPage, setBackToLoginPage] = useState(false);
  const [Retry, setRetry] = useState(false);
  const navigate = useNavigate();
  const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES;
  const [showStateDropdown, setShowStateDropdown] = useState(false);
  const [stateSearch, setStateSearch] = useState("");
  const [zones, setZones] = useState([]);
  const [filteredPincodes, setFilteredPincodes] = useState([]);
  const [selectedPincodes, setSelectedPincodes] = useState([]);
  const [pincodeSearch, setPincodeSearch] = useState('');
  const [showPincodeDropdown, setShowPincodeDropdown] = useState(false);
  const [isPincodeLoading, setIsPincodeLoading] = useState(false);
  const [manualPincodeLoading, setManualPincodeLoading] = useState(false);
  const [pincodeApiError, setPincodeApiError] = useState('');
  const [manualPincode, setManualPincode] = useState('');
  const [manualArea, setManualArea] = useState('');

  const states = [
    { value: 'Andhra Pradesh', label: 'Andhra Pradesh' },
    { value: 'Arunachal Pradesh', label: 'Arunachal Pradesh' },
    { value: 'Assam', label: 'Assam' },
    { value: 'Bihar', label: 'Bihar' },
    { value: 'Chhattisgarh', label: 'Chhattisgarh' },
    { value: 'Goa', label: 'Goa' },
    { value: 'Gujarat', label: 'Gujarat' },
    { value: 'Haryana', label: 'Haryana' },
    { value: 'Himachal Pradesh', label: 'Himachal Pradesh' },
    { value: 'Jharkhand', label: 'Jharkhand' },
    { value: 'Karnataka', label: 'Karnataka' },
    { value: 'Kerala', label: 'Kerala' },
    { value: 'Madhya Pradesh', label: 'Madhya Pradesh' },
    { value: 'Maharashtra', label: 'Maharashtra' },
    { value: 'Odisha', label: 'Odisha' },
    { value: 'Punjab', label: 'Punjab' },
    { value: 'Rajasthan', label: 'Rajasthan' },
    { value: 'Tamil Nadu', label: 'Tamil Nadu' },
    { value: 'Telangana', label: 'Telangana' },
    { value: 'Uttar Pradesh', label: 'Uttar Pradesh' },
    { value: 'West Bengal', label: 'West Bengal' },
  ];

  useEffect(() => {
    const fetchPincodesByCity = async () => {
      const cityQuery = HubData?.city?.trim();

      if (!cityQuery) {
        setFilteredPincodes([]);
        setPincodeApiError('');
        return;
      }

      setIsPincodeLoading(true);

      try {
        const response = await fetch(
          `https://api.postalpincode.in/postoffice/${encodeURIComponent(cityQuery)}`
        );

        const json = await response.json();

        if (
          !Array.isArray(json) ||
          json.length === 0 ||
          json[0]?.Status !== 'Success'
        ) {
          setFilteredPincodes([]);
          setPincodeApiError('No pincodes found');
          return;
        }

        const matches = (json[0].PostOffice || [])
          .map((office) => ({
            id: `${office.Pincode}-${office.Name}`,
            pincode: office.Pincode,
            area: office.Name,
          }))
          .filter(
            (item, index, arr) =>
              arr.findIndex(
                (x) =>
                  x.pincode === item.pincode &&
                  x.area === item.area
              ) === index
          );

        setFilteredPincodes(matches);
      } catch (error) {
        console.error(error);
        setPincodeApiError('Failed to fetch pincodes');
      } finally {
        setIsPincodeLoading(false);
      }
    };

    const delay = setTimeout(fetchPincodesByCity, 500);

    return () => clearTimeout(delay);
  }, [HubData?.city]);

  useEffect(() => {
    if (
      filteredPincodes.length === 0 ||
      !HubData?.servicable_pincodes?.length
    ) {
      return;
    }

    const mapped = HubData.servicable_pincodes.map((pin) => {
      const found = filteredPincodes.find(
        (item) => String(item.pincode) === String(pin)
      );

      return (
        found || {
          id: pin,
          pincode: String(pin),
          area: "Existing"
        }
      );
    });

    setSelectedPincodes(mapped);
  }, [filteredPincodes, HubData?.servicable_pincodes]);

  useEffect(() => {
    fetchZones();
  }, []);

  const fetchZones = async () => {
    try {
      const encryptedToken = sessionStorage.getItem('token');
      const token = decryptData(encryptedToken);
      const response = await fetch(`${fetchUrl}zone/get-all-zones`, {
        method: 'GET',
        headers: {
          'x-token': token,
        },
      });
      const responseData = await response.json();
      if (response.ok) {
        setZones(responseData.data || []);
      } else {
        console.error('Failed to fetch zones');
      }
    } catch (error) {
      console.error('Error fetching zones:', error);
    }
  };

  useEffect(() => {
    if (manualPincode.length === 6) {
      fetchAreaForPincode(manualPincode);
    }
  }, [manualPincode]);  

  useEffect(() => {
    if (HubData) {
      setImagePreview(HubData.logo ? `${imageUrl}${HubData.logo}` : null);
    }
  }, [HubData]);

  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;

  useEffect(() => {
    fetchHubsByHubId(HubData._id);
  }, []);
  
  const fetchHubsByHubId = async (hubId, attempt = 1) => {
    try {
      const encryptedToken = sessionStorage.getItem('token');
      const token = decryptData(encryptedToken);

      const getHubs = `${fetchUrl}hub/get-hubs-by-Id?hubId=${hubId}`;
      const response = await fetch(getHubs, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'x-token': token
        },
      });
      const data = await response.json();
      
      if (data.status === 200 || data.status === 201 || data.status === 204) {
        setHubData({
          ...data.data,
          zoneId: data.data.zoneId || "",
          latitude: data.data.location?.lat || "",
          longitude: data.data.location?.lng || ""
        });
        setHubs(data.data || []);
      } else if (data.status === 404) {
        setHubs([]);
        setPopupMessage(data.message);
        setPopupType('404');
        setShowPopup(true);
      } else if (data.status === 500) {
        setPopupMessage(data.message);
        setPopupType('500');
        setRetryFunction(() => fetchHubsByHubId);
        setShowPopup(true);
      } else {
        setPopupMessage(data.message);
        setPopupType(`${data.status}`);
        setShowPopup(true);
      }
    } catch (error) {
      console.error('Failed to fetch:', error);
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1);
        setTimeout(() => fetchHubsByHubId(hubId, attempt + 1), 1000);
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => fetchHubsByHubId(hubId, attempt));
      }
    }
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;

    let error = "";
    let updatedData = { ...HubData };

    if (name === "mobile_number") {
      if (value.length > 10 || !/^[0-9]*$/.test(value)) {
        return;
      }
      updatedData.mobile_number = value;
      if (value.length > 0 && value.length < 10) {
        error = "Enter 10 Digits Mobile Number";
      }
    }

    if (name === "email") {
      updatedData.email = value;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value && !emailRegex.test(value)) {
        error = "Please enter a valid email address";
      }
    }

    if (name === "gst") {
      const gstValue = value.toUpperCase();
      if (gstValue.length > 15) return;
      updatedData.gst = gstValue;
      const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/;
      if (gstValue.length === 15 && !gstRegex.test(gstValue)) {
        error = "Invalid GST format";
      }
      if (gstValue.length >= 12) {
        updatedData.pan = gstValue.substring(2, 12);
      }
    }

    if (name === "pan") {
      const panValue = value.toUpperCase();
      if (panValue.length > 10) return;
      updatedData.pan = panValue;
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      if (panValue.length === 10 && !panRegex.test(panValue)) {
        error = "Invalid PAN format";
      }
    }

    if (name === "zoneId") {
      updatedData.zoneId = value;
    }

    if (!["mobile_number", "email", "gst", "pan"].includes(name)) {
      updatedData[name] = value;
    }

    setHubData(updatedData);

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const filteredStates = states.filter((state) =>
    state.label.toLowerCase().includes(stateSearch.toLowerCase())
  ); 

  const handleCloseError = () => {
    setErrorMessages([]);
  };

  const handleSubmit = async (_id, attempt = 1) => {
    try {
      const encryptedToken = sessionStorage.getItem("token");
      const token = decryptData(encryptedToken);

      const formData = new FormData();

      const fields = [
        "hub_name",
        "company_name",
        "email",
        "mobile_number",
        "gst",
        "pan",
        "address1",
        "city",
        "pincode",
        "state",
        "website_url",
        "zoneId",
        "is_active",
      ];

      fields.forEach((field) => {
        if (
          HubData[field] !== undefined &&
          HubData[field] !== null
        ) {
          formData.append(field, HubData[field]);
        }
      });

      if (image instanceof File) {
        formData.append("logo", image);
      }

      const uniquePincodes = [
        ...new Set(
          selectedPincodes
            .map((item) => String(item.pincode).trim())
            .filter((pin) => pin !== "")
        ),
      ];

      uniquePincodes.forEach((pin) => {
        formData.append("servicable_pincodes", pin);
      });

      // Updated to utilize the flattened state for latitude and longitude 
      formData.append(
        "location",
        JSON.stringify({
          lat: HubData.latitude ? parseFloat(HubData.latitude) : null,
          lng: HubData.longitude ? parseFloat(HubData.longitude) : null,
        })
      );

      const response = await fetch(
        `${fetchUrl}hub/update-hub?_id=${HubData._id}`,
        {
          method: "PUT",
          headers: {
            "x-token": token,
          },
          body: formData,
        }
      );

      const responseData = await response.json();

      if (response.ok) {
        setPopupType("200or201");
        setPopupMessage("Hub updated successfully");
        setShowPopup(true);

        setHubData(responseData.data);

        setTimeout(() => {
          navigate("/bb/app/settings/hublist");
        }, 3000);
      } else {
        setErrorMessages([
          responseData.message || "Failed to update hub",
        ]);
      }
    } catch (error) {
      console.error("Update hub error:", error);
      setErrorMessages([
        "Internal Server Error. Kindly Retry.",
      ]);
    } finally {
      setIsLoading(false);
      setIsSaving(false);
    }
  };

  const handleStayHere = () => {
    setShowCancelPopup(false);
  }
  
  const handleCancel = () => {
    setShowCancelPopup(true);
  }
  
  const handleLeave = () => {
    navigate(-1);
  }
  
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const fetchAreaForPincode = async (pincode) => {
    if (!/^[0-9]{6}$/.test(pincode)) return;
    setManualPincodeLoading(true);

    try {
      const response = await fetch(
        `https://api.postalpincode.in/pincode/${pincode}`
      );
      const json = await response.json();

      if (
        Array.isArray(json) &&
        json[0]?.Status === 'Success'
      ) {
        const office = json[0].PostOffice?.[0];

        if (office) {
          setManualArea(
            office.Name ||
            office.Block ||
            office.District
          );
        }
      }
    } finally {
      setManualPincodeLoading(false);
    }
  };

  const addManualPincode = () => {
    if (!/^[0-9]{6}$/.test(manualPincode)) {
      setPincodeApiError(
        'Please enter valid 6 digit pincode'
      );
      return;
    }
    const cleaned = manualPincode.trim();

    const item = {
      id: `${cleaned}-${manualArea}`,
      pincode: cleaned,
      area: manualArea || "Manual Entry",
    };

    if (
      selectedPincodes.some(
        x => String(x.pincode) === String(manualPincode.trim())
      )
    ) {
      setPincodeApiError("Pincode already selected.");
      return;
    }

    setSelectedPincodes((prev) => [...prev, item]);
    setManualPincode('');
    setManualArea('');
  };

  const getLocation = () => {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          // Binding geolocation response straight to the HubData object
          setHubData(prevData => ({
            ...prevData,
            latitude: position.coords.latitude.toString(),
            longitude: position.coords.longitude.toString()
          }));
        });
    } else {
        alert('Geolocation is not supported by this browser.');
    }
  };
  
  return (
    <div className="bg-white flex flex-row w-full h-full overflow-y-hidden">
      <div className="flex flex-row w-full">
        <div className="w-full flex-1">
          <div className="flex flex-col w-full h-full justify-center items-center">
            <div className="w-full h-full flex flex-col justify-between">
              <div className="w-full h-16 border-b flex items-center">
                <div className="flex w-full justify-between px-4 items-center">
                  <h1 className="text-lg font-semibold">Edit Hub</h1>
                  
                  <span className=" absolute right-32  text-md font-semibold text-gray-600">Hub ID : {HubData.hub_number}</span>
                  

                </div>
              </div>
              {errorMessages.length > 0 && (
                <div className="flex justify-between items-center px-auto py-3 bg-[#fddcde] rounded-md">
                  <div className="px-6 flex flex-col justify-start items-start">
                    {errorMessages.map((errorMessage, index) => (
                      <span key={index} className="text-sm">
                        • {errorMessage}
                      </span>
                    ))}
                  </div>
                  <div className="px-4">
                    <button
                      className="text-gray-700 hover:text-red-500"
                      onClick={handleCloseError}
                    >
                      <FontAwesomeIcon icon={faX} className="text-xs text-[#F7525A] cursor-pointer" />
                    </button>
                  </div>
                </div>
              )}

              <div className="flex flex-col justify-start items-start w-full flex-grow h-80 overflow-y-auto">
                <div className="w-full flex flex-col justify-start items-start px-4 bg-[#F9F9FB]">
                <div className='w-full flex flex-row'>
                <div className="flex flex-col w-full">

                  <div className="w-full flex flex-row items-center mb-4 space-x-20 mt-5">
                    <label htmlFor="hub_name" className="block text-sm font-regular text-red-500 w-1/6">
                      Hub Name <span>*</span>
                    </label>
                    <input
                      type="text"
                      id="hub_name"
                      name="hub_name"
                      value={HubData.hub_name || ''}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    />
                    {errors.hub_name && <p className="text-red-500 text-sm">{errors.hub_name}</p>}
                  </div>

                  <div className="w-full flex flex-row items-center mb-4 space-x-20 mt-5">
                    <label htmlFor="company_name" className="block text-sm font-regular text-red-500 w-1/6">
                      Company Name <span>*</span>
                    </label>
                    <input
                      type="text"
                      id="company_name"
                      name="company_name"
                      value={HubData.company_name || ''}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    />
                    {errors.company_name && <p className="text-red-500 text-sm">{errors.company_name}</p>}
                  </div>

                  <div className="w-full flex flex-row items-center mb-4 space-x-20 mt-5">
                    <label
                      htmlFor="zoneId"
                      className="block text-sm font-regular text-red-500 w-1/6"
                    >
                      Zone <span>*</span>
                    </label>

                    <select
                      id="zoneId"
                      name="zoneId"
                      value={HubData.zoneId || ""}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    >
                      <option value="">Select Zone</option>

                      {zones.map((zone) => (
                        <option key={zone._id} value={zone._id}>
                          {zone.zone_name}
                        </option>
                      ))}
                    </select>

                    {errors.zoneId && (
                      <p className="text-red-500 text-sm">{errors.zoneId}</p>
                    )}
                  </div>

                  <div className="w-full flex flex-row items-center mb-4 space-x-20 mt-5">
                    <label htmlFor="email" className="block text-sm font-regular text-red-500 w-1/6">
                      Email <span>*</span>
                    </label>
                    <input
                      type="text"
                      id="email"
                      name="email"
                      value={HubData.email || ''}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    />
                    {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
                  </div>

                  <div className="w-full flex flex-row items-center mb-4 space-x-20 mt-5">
                    <label htmlFor="mobile_number" className="block text-sm font-regular text-red-500 w-1/6">
                      Mobile Number <span>*</span>
                    </label>
                    <input
                      type="text"
                      id="mobile_number"
                      name="mobile_number"
                      value={HubData.mobile_number || ''}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    />
                    {errors.mobile_number && <p className="text-red-500 text-sm">{errors.mobile_number}</p>}
                  </div>
                  </div>
                  <div className='w-1/2 justify-start items-start mt-5'>

                  {/* Logo Upload Section */}
                  <div className=" w-1/2 h-[50%] border-2 border-dashed border-gray-300 rounded-lg flex justify-center items-center relative">
                <input
                  type="file"
                  id="itemImage"
                  accept="image/*"
                  className="absolute inset-0 opacity-0 cursor-pointer"
                  onChange={handleImageUpload}
                />
                {imagePreview ? (
                  <img
                    src={imagePreview}
                    alt="Preview"
                    className="w-24 h-24 object-cover rounded-lg"
                  />
                ) : (
                  <div className="text-gray-400 text-center">Click to upload image</div>
                )}
              </div>
              </div>
              </div>
              </div>
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5 px-4">
  <label htmlFor="gst" className="block text-sm font-regular text-red-500 w-1/6">
    GST <span> *</span>
  </label>
  <input
    type="text"
    id="gst"
    name="gst"
    value={HubData.gst || " "}
    onChange={handleChange}
    className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
  />
  {errors.gst && <p className="text-red-500 text-sm">{errors.gst}</p>}
</div>

<div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5 px-4">
  <label htmlFor="pan" className="block text-sm font-regular text-red-500 w-1/6">
    PAN <span> *</span>
  </label>
  <input
    type="text"
    id="pan"
    name="pan"
    value={HubData.pan || ""}
     readOnly
    className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
  />
  {errors.pan && <p className="text-red-500 text-sm">{errors.pan}</p>}
</div>

<div className="flex flex-col w-full px-4">
  <div className="flex flex-row space-x-3  text-black text-opacity-80 text-base self-stretch whitespace-nowrap mt-3">
    <div className='flex flex-row text-sm space-x-2'> Add Location : </div>
    <button onClick={getLocation}><MdAddLocationAlt className='text-xl border border-[#000000]'/></button>
  </div>
  
  <div className="w-full flex flex-col md:flex-row items-start md:items-center mb-4 mt-5 md:space-x-20">
  <label htmlFor="latitude" className="block text-sm font-regular text-gray-700 w-full md:w-1/6 mb-2 md:mb-0">
    Latitude
  </label>
  <input
    className="w-full md:w-1/2 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
    type="text"
    placeholder="Enter Latitude"
    id='latitude'
    name='latitude' // ADDED name attribute
    value={HubData.latitude || ''}
    onChange={handleChange}
  />
</div>


<div className="w-full flex flex-col md:flex-row items-start md:items-center mb-4 mt-5 md:space-x-20">
  <label htmlFor="longitude" className="block text-sm font-regular text-gray-700 w-full md:w-1/6 mb-2 md:mb-0">
    Longitude
  </label>
  <input
    className="w-full md:w-1/2 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
    type="text"
    placeholder="Enter Longitude"
    id='longitude'
    name='longitude' // ADDED name attribute
    value={HubData.longitude || ''}
    onChange={handleChange}
  />
</div>
</div>

  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5 px-4">
  <label htmlFor="address1" className="block text-sm font-regular text-gray-700 w-1/6">
    Address
  </label>
  <input
    type="text"
    id="address1"
    name="address1"
    value={HubData.address1 || ''}
    onChange={handleChange}
    className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
  />
  {errors.address1 && <p className="text-red-500 text-sm">{errors.address1}</p>}
</div>

<div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5 px-4">
  <label htmlFor="city" className="block text-sm font-regular text-gray-700 w-1/6">
    City
  </label>
  <input
    type="text"
    id="city"
    name="city"
    value={HubData.city || ''}
    onChange={handleChange}
    className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
  />
  {errors.city && <p className="text-red-500 text-sm">{errors.city}</p>}
</div>

<div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5 px-4">
  <label className="block text-sm font-regular text-gray-700 w-1/6">
    Serviceable Pincodes
  </label>

  <div className="w-1/3 relative">

    {/* Dropdown Header */}

    <div
      className="w-full flex items-center justify-between border border-gray-300 rounded-md px-3 py-2 bg-white cursor-pointer"
      onClick={() => setShowPincodeDropdown((prev) => !prev)}
    >
      <span>
        {selectedPincodes.length > 0
          ? `${selectedPincodes.length} selected`
          : "Select city to load pincodes"}
      </span>

      <FiChevronDown />
    </div>

    {/* Entire dropdown body from NewHub */}
        {showPincodeDropdown && (
          <div className="absolute z-50 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-[420px] overflow-hidden">
            <div className="border-b px-2 py-2">
              <div className="flex items-center gap-2">
                <FiSearch className="text-gray-400" size={16} />
                <input
                  type="text"
                  placeholder="Search pincode or area..."
                  value={pincodeSearch}
                  onChange={(e) => setPincodeSearch(e.target.value)}
                  className="w-full py-2 outline-none text-sm"
                />
              </div>
            </div>
    
            <div className="max-h-56 overflow-y-auto">
              {isPincodeLoading ? (
                <div className="px-3 py-4 flex items-center gap-2 text-sm text-gray-500">
                  <Spinner />
                  Fetching pincodes...
                </div>
              ) : filteredPincodes.filter((item) =>
                `${item.pincode} ${item.area}`.toLowerCase().includes(pincodeSearch.toLowerCase())
              ).length > 0 ? (
                filteredPincodes
                  .filter((item) =>
                    `${item.pincode} ${item.area}`.toLowerCase().includes(pincodeSearch.toLowerCase())
                  )
                  .map((item) => {
                    const isSelected = selectedPincodes.some(
                      (selected) => selected.pincode === item.pincode
                    );
                    return (
                      <div
                        key={item.id}
                        className="flex items-center justify-between px-3 py-2 hover:bg-gray-50 cursor-pointer"
                        onClick={() => {
                          setSelectedPincodes((prev) =>
                            prev.some(
                              (selected) => selected.pincode === item.pincode
                            )
                              ? prev.filter(
                                    (selected) =>
                                      selected.pincode !== item.pincode
                                  )
                              : [...prev, item]
                          );
                        }}
                      >
                        <div>
                          <p className="text-sm font-medium text-gray-900">{item.pincode}</p>
                          <p className="text-xs text-gray-500">{item.area}</p>
                        </div>
                        <input
                          type="checkbox"
                          readOnly
                          checked={isSelected}
                          className="h-4 w-4 text-blue-600 rounded border-gray-300"
                        />
                      </div>
                    );
                  })
              ) : (
                <div className="px-3 py-3 text-sm text-gray-500">
                  {pincodeApiError || 'No pincodes found for this city.'}
                </div>
              )}
            </div>
    
            <div className="border-t px-3 py-3 bg-[#f9fafb]">
              <p className="text-sm text-gray-700">Add pincode manually anytime.</p>
              <div className="mt-2 grid gap-2 sm:grid-cols-3">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Pincode"
                    value={manualPincode}
                    onChange={(e) => {
                      setManualPincode(e.target.value);
                      if (pincodeApiError) setPincodeApiError('');
                    }}
                    className="w-full rounded-md border border-gray-300 px-2 py-2 text-sm"
                  />
                  {manualPincodeLoading && (
                    <div className="absolute inset-y-0 right-2 flex items-center">
                      <Spinner />
                    </div>
                  )}
                </div>
                <input
                  type="text"
                  placeholder="Area name (optional)"
                  value={manualArea}
                  onChange={(e) => setManualArea(e.target.value)}
                  className="w-full rounded-md border border-gray-300 px-2 py-2 text-sm"
                />
                <button
                  type="button"
                  onClick={addManualPincode}
                  className="rounded-md bg-[#408dfb] px-3 py-2 text-sm text-white hover:bg-[#3077d6]"
                >
                  Add
                </button>
              </div>
              {pincodeApiError && (
                <p className="mt-2 text-sm text-red-500">{pincodeApiError}</p>
              )}
            </div>
          </div>
        )}

<div className="mt-2 flex flex-wrap gap-2">
  {selectedPincodes.map((item) => (
    <div
      key={item.pincode}
      className="flex items-center gap-2 bg-blue-100 text-blue-700 px-2 py-1 rounded-md text-xs"
    >
      {item.pincode}

      <button
        type="button"
        onClick={() =>
          setSelectedPincodes((prev) =>
            prev.filter(
              (x) =>
                x.pincode !== item.pincode
            )
          )
        }
      >
        ×
      </button>
    </div>
  ))}
</div>

  </div>
</div>

<div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5 px-4">
  <label htmlFor="pincode" className="block text-sm font-regular text-gray-700 w-1/6">
    Pincode
  </label>
  <input
    type="text"
    id="pincode"
    name="pincode"
    value={HubData.pincode || ''}
    onChange={handleChange}
    className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
  />
  {errors.pincode && <p className="text-red-500 text-sm">{errors.pincode}</p>}
</div>

<div className="w-full flex flex-row items-start mb-4 space-x-2 mt-5 px-4 relative">

  <label className="block text-sm font-regular text-gray-700 w-1/6">
    State
  </label>

  <div className="w-1/3 relative">

    {/* Input with dropdown icon */}
    <div
      onClick={() => setShowStateDropdown(!showStateDropdown)}
      className="w-full flex items-center justify-between border border-gray-300 rounded-md hover:border-blue-500 px-2 py-2 cursor-pointer bg-white"
    >
      <input
        type="text"
        value={HubData.state || ""}
        placeholder="Select state"
        readOnly
        className="outline-none text-sm text-gray-700 w-full cursor-pointer"
      />

      <FiChevronDown
        className={`text-gray-500 transition-transform ${
          showStateDropdown ? "rotate-180" : ""
        }`}
        size={18}
      />
    </div>

    {/* Dropdown */}
    {showStateDropdown && (
      <div className="absolute z-50 w-full bg-white border border-gray-300 rounded-md shadow-lg mt-1">

        {/* Search */}
        <div className="flex items-center border-b px-2">
          <FiSearch className="text-gray-400 mr-2" />

          <input
            type="text"
            placeholder="Search state..."
            value={stateSearch}
            onChange={(e) => setStateSearch(e.target.value)}
            className="w-full py-2 outline-none text-sm"
            autoFocus
          />
        </div>

        {/* State list */}
        <div className="max-h-48 overflow-y-auto">
          {filteredStates.length > 0 ? (
            filteredStates.map((state) => (
              <div
                key={state.value}
                onClick={() => {
                  setHubData({
                    ...HubData,
                    state: state.label,
                  });
                  setShowStateDropdown(false);
                  setStateSearch("");
                }}
                className="px-3 py-2 hover:bg-blue-50 cursor-pointer text-sm"
              >
                {state.label}
              </div>
            ))
          ) : (
            <div className="px-3 py-2 text-gray-400 text-sm">
              No states found
            </div>
          )}
        </div>

      </div>
    )}

  </div>

</div>

<div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5 px-4">
  <label htmlFor="website_url" className="block text-sm font-regular text-gray-700 w-1/6">
    Website URL
  </label>
  <input
    type="text"
    id="website_url"
    name="website_url"
    value={HubData.website_url || ''}
    onChange={handleChange}
    className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
  />
{errors.website_url && <p className='text-red-500 text-sm'>{errors.website_url}</p>}
</div>


                </div>
              </div>

              <div className="mt-5 w-full">
<hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
                  <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
                    <button
                      className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md inline-flex items-center"
                      onClick={() => handleSubmit(HubData._id)}

                      disabled={isSaving}
                    >
                      <span>Update</span>
                      {isSaving && <Spinner />}
                    </button>
                    <button
                      className={`hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
                        isSaving ? 'bg-gray-400 text-gray-500 cursor-not-allowed' : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
                      }`}
                      disabled={isSaving}
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                  </div>
                  </div>

            </div>
          </div>
        </div>
        {showCancelPopup && (
    <div className="fixed inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50 ">
    <div className="bg-white rounded-b-md shadow-md w-[550px] h-[250px] flex flex-col" style={{ maxWidth: '550px', maxHeight: '250px' }}>
    <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-14 px-6'>
    <h2 className="text-md font-semibold">
    <FontAwesomeIcon icon={faExclamationTriangle} className="text-xl text-yellow-500 mr-4 " />
      Leave this page?</h2>
      <button onClick={handleStayHere} className="text-white px-1 py-1 rounded-md ">   
        <FontAwesomeIcon icon={faX} className="text-xs text-[#212529] cursor-pointer " />
      </button>
    </div>
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      <div className='pt-4 pl-4 '>
    <div className="w-full items-center p-5">
      <label htmlFor="Other_details" className="block text-sm font-regular text-[#212529] ">
      If you leave, your unsaved changes will be discarded.
      </label>
    </div>  
  </div>
      <div className="mt-auto w-full">
        <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
        <div className="text-sm flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
        <button className="px-2 py-1 bg-[#408dfb] border-[#f7525a] text-white rounded-md" onClick={handleStayHere}>
  Stay Here  {isSaving && (
      <Spinner/>
    )}
  </button>
          <button onClick={handleLeave} 
          className="hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50  px-2 py-1 bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD] rounded-md">
            Leave & Discard Changes</button>
        </div>
      </div>
    </div>
  </div>
)}

{showPopup && (
  <div>
    {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
    {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
    {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
          {popupType === '401' && <Msg401 message={popupMessage} closePopup={closePopup} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup}/>}
  </div>
)}

      </div>
    
  );
}

export default EditHub;